<template>
	<div class="product-specification py-8 md:w-4/5 text-lg">
    <p>
      <span class="font-semibold">Size / Dimension: </span>
      <span>{{ product.specification.displaySize }}</span>
    </p>
    <p>
      <span class="font-semibold">Weight: </span>
      <span>{{ product.specification.displayWeight }}</span>
    </p>
     <p>
      <span class="font-semibold">Material: </span>
      <span>
        <span
          v-for="(material, index) in product.materials"
          :key="`material-${material}-${index}`"
        >
          {{ material }}<span v-if="index !== product.materials.length - 1">,
          </span>
        </span>
      </span>
    </p>
    <p>
      <span class="font-semibold">Color(s): </span>
      <span>
        <span
          v-for="(color, index) in product.colors"
          :key="`color-${color}`"
        >
          {{ color }}<span v-if="index !== product.colors.length - 1">,
          </span>
        </span>
      </span>
    </p>
    <p>
      <span class="font-semibold">Layer(s): </span>
      <span>{{ product.specification.layer }}</span>
    </p>
    <p>
      <span class="font-semibold">Shape: </span>
      <span>{{ product.specification.shape }}</span>
    </p>
    <p>
      <span class="font-semibold">Dangerous Goods: </span>
      <span>{{ product.specification.dangerous }}</span>
    </p>
    <p>
        <span class="font-semibold">Place of Origin: </span>
        <span>{{ product.country }}</span>
      </p>
      <p>
        <span class="font-semibold">Payments Terms: </span>
        <span>
          <!-- {{ product.paymentTerms }} -->
          Due to the COVID-19 Pandemic, all orders require 100% payment in advance upon placement of the order. BuyHive will ensure that orders are produced according to buyer expectations or will refund the buyer's payment.
        </span>
      </p>
       <p>
        <span class="font-semibold">Model Numbers: </span>
        <span>{{ product.modelNumber }}</span>
      </p>
      <p>
        <span class="font-semibold">Certifications: </span>
        <span
          v-for="(certificate, index) in product.certificates"
          :key="`certificate-${index}`"
        >
          <a
            :href="certificate.url"
            target="_blank"
            class="text-blue"
          >
            {{ certificate.type }}
          </a><span
            v-if="index !== product.certificates.length - 1"
          >, </span>
        </span>
      </p>
      <p>
        <span class="font-semibold">Standards: </span>
        <span
          v-for="(standard, index) in product.standards"
          :key="`standard-${index}`"
        >
          <a
            :href="standard.url"
            target="_blank"
            class="text-blue"
          >
            {{ standard.type }}
          </a><span
            v-if="index !== product.standards.length - 1"
          >, </span>
        </span>
      </p>
  </div>
</template>
<script>
export default {
	name: 'ProductSpecification',
	props: {
		product: {
			required: true
		}
	}
}
</script>
<style lang="scss" scoped>
  .product-specification {
    p {
      @apply pb-2;
    }
  }
</style>
